import styled from 'styled-components';

export const HasAssistanceStyles = styled.div`
  min-height: calc(100vh - 212px);
  display: flex;
  flex-direction: column;

  .truck-img {
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
      margin-bottom: 24px;
    }
  }
  .invalid-text {
    span {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    margin-bottom: 8px;
  }
  .contact-block {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;

    .MuiButtonBase-root {
      width: 80%;
      align-self: flex-end;
    }
  }
`;
